import React from 'react'
import Footer from '../Footer'
import Header from './Header'
import { Link } from 'react-router-dom'


function Home() {
    document.title='HR School - Home'
  return (
    <div>
        <Header/>
        <section id="news-part" class="pt-115 pb-110">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="section-title pb-50">
                        <h5>Latest News</h5>
                        <h2>From the news</h2>
                    </div> 
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="singel-news mt-30">
                        <div class="news-thum pb-25">
                            <img src="images/news/n-1.jpg" alt="News"/>
                        </div>
                        <div class="news-cont">
                            <ul>
                                <li><Link to="/"><i class="fa fa-calendar"></i>2 December 2018 </Link></li>
                                <li><Link to="/"> <span>By</span> Adam linn</Link></li>
                            </ul>
                            <Link to="/"><h3>Tips to grade high cgpa in university life</h3></Link>
                            <p>Lorem ipsum gravida nibh vel velit auctor aliquetn sollicitudirem quibibendum auci elit cons equat ipsutis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt .</p>
                        </div>
                    </div> 
                </div>
                <div class="col-lg-6">
                    <div class="singel-news news-list">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="news-thum mt-30">
                                    <img src="images/news/ns-1.jpg" alt="News"/>
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <div class="news-cont mt-30">
                                    <ul>
                                        <li><Link to="/"><i class="fa fa-calendar"></i>2 December 2018 </Link></li>
                                        <li><Link to="/"> <span>By</span> Adam linn</Link></li>
                                    </ul>
                                    <Link to="/"><h3>Intellectual communication</h3></Link>
                                    <p>Gravida nibh vel velit auctor aliquetn sollicitudirem quibibendum auci elit cons  vel.</p>
                                </div>
                            </div>
                        </div> 
                    </div> 
                    <div class="singel-news news-list">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="news-thum mt-30">
                                    <img src="images/news/ns-2.jpg" alt="News"/>
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <div class="news-cont mt-30">
                                    <ul>
                                        <li><Link to="/"><i class="fa fa-calendar"></i>2 December 2018 </Link></li>
                                        <li><Link to="/"> <span>By</span> Adam linn</Link></li>
                                    </ul>
                                    <Link to="/"><h3>Study makes you perfect</h3></Link>
                                    <p>Gravida nibh vel velit auctor aliquetn sollicitudirem quibibendum auci elit cons  vel.</p>
                                </div>
                            </div>
                        </div> 
                    </div> 
                    <div class="singel-news news-list">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="news-thum mt-30">
                                    <img src="images/news/ns-3.jpg" alt="News"/>
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <div class="news-cont mt-30">
                                    <ul>
                                        <li><Link to="/"><i class="fa fa-calendar"></i>2 December 2018 </Link></li>
                                        <li><Link to="/"> <span>By</span> Adam linn</Link></li>
                                    </ul>
                                    <Link to="/"><h3>Technology edcution is now....</h3></Link>
                                    <p>Gravida nibh vel velit auctor aliquetn sollicitudirem quibibendum auci elit cons  vel.</p>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div> 
        </div> 
    </section>
    <Footer/>
    </div>
  )
}

export default Home